import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

type Teammember = { id: string; name: string; surname: string; role: string; link: string; created_at: Date; attachment: { url: string; }[], organization: string}

export function useGetTeammembers() {
  return useFetch<Teammember[]>(getAbsoluteServerUrl('/teammembers'), { responseType: 'json' }, [])
}
